/** @jsx jsx */
import { jsx } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../sanityConfig";
import { getGatsbyImageData } from "gatsby-source-sanity";
import PortableTextComponent from "./portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";
import BenefitsPardot from "./benefitsPardot";

const ImageLeftTextRight = ({ value }) => {
  const gatsbyImageData = getGatsbyImageData(
    value.image,
    { maxWidth: 800 },
    sanityConfig
  );
  return (
    <div
      id={value?.id?.current ? value?.id?.current : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        paddingTop: "6",
        paddingBottom: "6",
      }}
    >
      <Container>
        <div
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            flexDirection: [
              "column",
              "column",
              value?.iamge_position == "left" ? "row" : "row-reverse",
            ],
            justifyContent: "space-between",
          }}
          className="text-image-container"
        >
          <div
            className="text-image-image"
            sx={{
              paddingLeft: ["0px", "0px", "70px"],
              marginBottom: ["40px", "40px", "0px"],
              width: ["100%", "100%", "400px"],
            }}
          >
            <div
              sx={{
                maxWidth: ["100%", "100%", "400px"],
                maxHeight: ["100%", "100%", "300px"],
                height:"300px",
                display:"flex",
                alignItems:"center",
                ".gatsby-image-wrapper":{
                  maxHeight:"100%",
                  maxWidth:"100%",
                  img:{
                    objectFit: "contain !important",
                  }
                },
                // img:{
                //   height:"auto",
                //   width:"100%",
                // }
              }}
            >
              <GatsbyImage image={gatsbyImageData} />
            </div>
          </div>
          <div
            className="text-image-text"
            sx={{
              color: "textGray",
              fontSize: "body",
              width: ["100%", "100%", "calc(100% - 610px)"],
              "h1,h2,h3,h4,h5,h6": {
                color: "primary",
              },
              h2: {
                fontSize: "2.375rem",
                lineHeight: "1.2",
                margin: "0 0 20px",
                maxWidth: "555px",
              },
            }}
          >
            {value.headline && <h2>{value.headline}</h2>}
            {value.subhead && <h3>{value.subhead}</h3>}

            <PortableText
              value={value.text}
              components={PortableTextComponent}
            />
            {value?.id?.current == "benefits-pardot" && <BenefitsPardot />}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ImageLeftTextRight;
